module.exports = __webpack_public_path__ + "Download_Icon.a0a62de4194cfa698cd7.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/images/Download_Icon.png
// module id = ../../../../../src/assets/images/Download_Icon.png
// module chunks = main